namespace uh.storage {
    export class LocalStorageController {

        private static _instance:LocalStorageController = null;
        public static get instance() {
            if (!LocalStorageController._instance) {
                LocalStorageController._instance = new LocalStorageController();
            }
            return LocalStorageController._instance;
        };

        private isLocalStorageSupported:boolean = false;
        private readonly name:string = "unseen-heroes-v2";
        public data:Object = null;

        constructor() {
            this.data = {
                "best": 0
            };

            this.checkLocalStorageSupported();
            this.createOrLoad();
        }

        public flush():void {
            if (!this.isLocalStorageSupported)
                return;

            localStorage[this.name] = JSON.stringify(this.data);
        }

        private createOrLoad():void {
            if (!this.isLocalStorageSupported)
                return;
            if (localStorage[this.name]) {//localStorage exist
                this.data = JSON.parse(localStorage[this.name]);
            } else {
                this.flush();
            }
        }

        private checkLocalStorageSupported():void {
            try {
                this.isLocalStorageSupported = "localStorage" in window && window["localStorage"] !== null;
            }
            catch (e) {
                this.isLocalStorageSupported = false;
            }
        }

        public getBest():number {
            return this.data["best"];
        }

        public setBest(best:number):void {
            this.data["best"] = best;
            this.flush();
        }
    }
}